import * as React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import PropTypes from "prop-types";
import { ChartColors } from "../../theme";
import moment from "moment";
import { CyNumber } from "../../utilities/number";
import { AppTheme } from "../../theme";

const CyRiskPanicLabel = (props) => {
  const { x, y, stroke, value, highlight, panicPoint } = props;

  if (highlight.Close !== value && panicPoint.Close !== value) {
    return null;
  }
  return (
    <g>
      <g transform="translate(0 -65)">
        <text
          x={x}
          y={y}
          dy={-20}
          fill={stroke}
          fontSize={14}
          textAnchor="middle"
        >
          <tspan x={x} dy="1.2em">
            You
          </tspan>
          <tspan x={x} dy="1.2em">
            stopped
          </tspan>
          <tspan x={x} dy="1.2em">
            here
          </tspan>
        </text>
      </g>
      <circle
        r="6"
        stroke={AppTheme.palette.error.main}
        strokeWidth="1"
        fill={AppTheme.palette.error.main}
        width={6}
        height={6}
        cx={x}
        cy={y}
      />
    </g>
  );
};

const CyRiskXTick = (props) => {
  const { x, y, payload } = props;
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        fontSize={12}
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill={AppTheme.palette.grey[700]}
        transform="rotate(0)"
      >
        {moment(payload.value).format("MMM-YY")}
      </text>
    </g>
  );
};

class CyRiskChart extends React.Component {
  state = {
    panicPoint: {
      Close: null,
      Date: null,
    },
    showHighlight: true,
  };

  update = (v) => {
    if (v !== null && v.activePayload) {
      const panicPoint = v.activePayload[0].payload;
      this.setState({ panicPoint: panicPoint, showHighlight: false });
      this.props.onUpdate(panicPoint);
    }
  };

  updateConditional = (v) => {
    let userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      iosPlatforms = ["iPhone", "iPad", "iPod"];

    if (iosPlatforms.indexOf(platform) !== -1 || /Android/.test(userAgent)) {
      this.update(v);
    }
  };

  renderTooltipLabel = (value) => {
    return moment(value).format("MMM DD, YYYY");
  };

  render() {
    const { data, height, simplified, highlight } = this.props;
    const { NumberFormatter } = CyNumber;
    const chartColors = ChartColors();

    if (simplified) {
      return (
        <ResponsiveContainer width={"100%"} height={height}>
          <LineChart data={data} margin={{ top: 5, bottom: 5 }}>
            <XAxis hide dataKey="Date" />
            <YAxis hide domain={[600, 1600]} tickFormatter={NumberFormatter} />
            <Line
              strokeWidth={3}
              dataKey="Close"
              dot={false}
              stroke={chartColors.next().value}
            />
          </LineChart>
        </ResponsiveContainer>
      );
    } else {
      return (
        <ResponsiveContainer width={"100%"} height={height}>
          <LineChart
            data={data}
            margin={{ top: 5, bottom: 5 }}
            onClick={this.update}
            onMouseMove={this.updateConditional}
          >
            <XAxis dataKey="Date" minTickGap={30} tick={<CyRiskXTick />} />
            <YAxis domain={[600, 1600]} tickFormatter={NumberFormatter} />
            <CartesianGrid vertical={false} />
            <Line
              strokeWidth={3}
              dataKey="Close"
              dot={false}
              stroke={chartColors.next().value}
              label={
                <CyRiskPanicLabel
                  highlight={this.state.showHighlight && highlight}
                  panicPoint={this.state.panicPoint}
                />
              }
            />
            <Tooltip
              formatter={NumberFormatter}
              labelFormatter={this.renderTooltipLabel}
            />
          </LineChart>
        </ResponsiveContainer>
      );
    }
  }
}

CyRiskChart.propTypes = {
  data: PropTypes.array.isRequired,
  simplified: PropTypes.bool,
  highlight: PropTypes.object,
};

CyRiskChart.defaultProps = {
  simplified: true,
};

export default CyRiskChart;



// WEBPACK FOOTER //
// ./src/components/Charts/CyRiskChart.jsx